import { CardContent, Grid, Paper, Typography } from '@material-ui/core';
import React from 'react';
import useStyles from './sampleDevelopmentNl.style';
import SampleDevelopmentNlPrintingBack from './SampleDevelopmentNlPrintingBack';
import SampleDevelopmentNlPrintingFront from './SampleDevelopmentNlPrintingFront';

interface SampleDevelopmentNlPrintingProps {
  isCrtLocked?: boolean;
}

const SampleDevelopmentNlPrinting: React.FC<SampleDevelopmentNlPrintingProps> = (
  props,
) => {
  const { isCrtLocked = false } = props;
  const classes = useStyles();

  return (
    <Paper variant="outlined">
      <Typography className={classes.title}>Printing</Typography>
      <CardContent>
        <Grid container spacing={1} direction="row" justifyContent="flex-start">
          <Grid item xs={12} sm={6} container>
            <SampleDevelopmentNlPrintingFront isCrtLocked={isCrtLocked} />
          </Grid>
          <Grid item xs={12} sm={6} container>
            <SampleDevelopmentNlPrintingBack isCrtLocked={isCrtLocked} />
          </Grid>
        </Grid>
      </CardContent>
    </Paper>
  );
};

export default SampleDevelopmentNlPrinting;
